// extracted by mini-css-extract-plugin
export default {"mainPartRight":"items-module__mainPartRight--S4h9o","mainPartLast":"items-module__mainPartLast--iXkpc"};